<div class="task-schedule">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-lavuro m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-capitalize">
          Programado en
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-12 task-schedule-content">
      <form *ngIf="form" class="m-0" [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <input matInput name="title" formControlName="title" placeholder="Título / Asunto" type="text"
                [readonly]="readOnly">
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>
                Estado
              </mat-label>
              <mat-select name="status" formControlName="status" [disabled]="true"
                [ngClass]="{ 'is-invalid': submitted && f['status'].errors }">
                <mat-option *ngFor="let status of taskStatusesKeys" [value]="status">{{taskStatuses[status]}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-error *ngIf="submitted && f['status']?.errors?.['required']">
              Estado Obligatorio
            </mat-error>
            <mat-error *ngIf="submitted && f['status']?.errors?.['datesRequired']">
              Indicar Fecha Inicio/Fin
            </mat-error>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-lg-6">
            <mat-form-field appearance="outline">
              <input matInput name="scheduledStart" formControlName="scheduledStart"
                (ngModelChange)="scheduledStartChange()" placeholder="Programado en (Fecha/Hora Inicio)"
                type="datetime-local" #dobInput [readonly]="readOnly">
            </mat-form-field>
            <mat-error *ngIf="f['scheduledStart']?.errors?.['tooEarly']">
              La fecha es muy antigua.
            </mat-error>
            <mat-error *ngIf="f['scheduledStart']?.errors?.['bothRequired']">
              Ambas fechas requeridas.
            </mat-error>
          </div>
          <div class="col-md-6 col-lg-6">
            <mat-form-field appearance="outline">
              <input matInput name="scheduledEnd" formControlName="scheduledEnd"
                placeholder="Programado en (Fecha/Hora Fin)" type="datetime-local" #dobInput [readonly]="readOnly">
            </mat-form-field>
            <mat-error *ngIf="f['scheduledEnd']?.errors?.['lowerThanStart']">
              La fecha es menor al Inicio.
            </mat-error>
            <mat-error *ngIf="f['scheduledEnd']?.errors?.['bothRequired']">
              Ambas fechas requeridas.
            </mat-error>
          </div>
        </div>

        <div class="row">
          <div class="col-12 pt-4">
            <button mat-raised-button [disabled]="saving" type="submit" class="m-0 ml-1 pull-right btn btn-lavuro">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
              Guardar
            </button>
            <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-link d-none d-md-inline"
              (click)="dialog.close(false)">
              Cancelar
            </button>
          </div>
        </div>

      </form>
    </div>
  </div>
</div>